import { License, SelectedActivationsType } from '@/types/license';
import { Product } from '@/types/products';
import { Action } from '../../actions';

export type UpgradeToV5Page = {
  upgradeStep: 'features' | 'activations' | null;
  licenseSerial: License['Serial'] | undefined | null;
  upgradeTarget: Product | undefined | null;
  selectedActivations: SelectedActivationsType;
};

const defaultState = {
  upgradeStep: null,
  licenseSerial: null,
  upgradeTarget: null,
  selectedActivations: null,
};

export default function upgradeToV5PageReducer(
  state: UpgradeToV5Page = defaultState,
  action: Action,
): UpgradeToV5Page {
  switch (action.type) {
    case 'CHOOSE_UPGRADE_TARGET':
      return Object.assign({}, state, {
        upgradeTarget: action.upgradeTarget,
        selectedActivations: null,
      });
    case 'CHOOSE_UPGRADE_ACTIVATIONS':
      return Object.assign({}, state, {
        selectedActivations: action.selectedActivations,
      });
    default:
      return state;
  }
}
